import React, { useState } from "react";
import { FileExcelOutlined, FormOutlined } from "@ant-design/icons";
import RegisterOrder from "./RegisterOrder";
import RegisterOrders from "./RegisterOrders";
import useLang from "../../hooks/useLang";
import classes from "./Register.module.css";

type RegisterTab = "register" | "excel";

/**
 * Register order: one order through the form, or many at once from an Excel file.
 *
 * The two modes are large tabs with an icon, rather than two bare words, so the Excel import is as
 * easy to find as the form. Their labels say what each is for, so they carry no second line.
 */
const Register = () => {
	const [activeTab, setActiveTab] = useState<RegisterTab>("register");
	const { strings } = useLang("registerOrderForm");

	const tabs: {
		key: RegisterTab;
		icon: React.ReactNode;
		label?: string;
	}[] = [
		{
			key: "register",
			icon: <FormOutlined />,
			label: strings?.tabRegister,
		},
		{
			key: "excel",
			icon: <FileExcelOutlined />,
			label: strings?.tabExcel,
		},
	];

	return (
		<div className={classes.page}>
			<div className={classes.tabsCard}>
				<div
					role="tablist"
					aria-label={strings?.tabsLabel}
					className={classes.tabs}
				>
					{tabs.map((tab) => {
						const selected = tab.key === activeTab;
						return (
							<button
								key={tab.key}
								type="button"
								role="tab"
								id={`register-tab-${tab.key}`}
								aria-selected={selected}
								aria-controls={`register-panel-${tab.key}`}
								className={`${classes.tab} ${
									selected ? classes.tabActive : ""
								}`}
								onClick={() => setActiveTab(tab.key)}
							>
								<span
									className={classes.tabIcon}
									aria-hidden="true"
								>
									{tab.icon}
								</span>
								<span className={classes.tabLabel}>
									{tab.label}
								</span>
							</button>
						);
					})}
				</div>
			</div>

			<div
				role="tabpanel"
				id={`register-panel-${activeTab}`}
				aria-labelledby={`register-tab-${activeTab}`}
				className={classes.panel}
			>
				{activeTab === "register" ? (
					<RegisterOrder />
				) : (
					<RegisterOrders />
				)}
			</div>
		</div>
	);
};

export default Register;
